module.exports = __webpack_public_path__ + "img/hide-small.21411431.svg";